import { PagoNubeInvoiceHistoryDataTable } from './components';

function PagoNubeInvoiceHistoryMobileSkeleton(): JSX.Element {
  return <PagoNubeInvoiceHistoryDataTable.Skeleton />;
}
export default PagoNubeInvoiceHistoryMobileSkeleton;
